import { useCallback } from 'react';
import {
  getCredentialsGroup,
  getCredentialsGroups,
  addCredentialsGroup,
  updateCredentialsGroup,
} from 'js/actions';
import useAppDispatch from 'js/hooks/useAppDispatch';

export default function useCredentialsGroupsAdapter() {
  const dispatch = useAppDispatch();

  const loadCredentialsGroup = useCallback((id: number) => {
    return dispatch(getCredentialsGroup(id));
  }, []);

  const loadCredentialsGroups = useCallback(() => {
    return dispatch(getCredentialsGroups());
  }, []);

  const createCredentialsGroup = useCallback((name: string, dataCredentials: number[]) => {
    return dispatch(addCredentialsGroup(name, dataCredentials));
  }, []);

  const updateCredentialsGroupInfo = useCallback((id: number, info: any) => {
    return dispatch(updateCredentialsGroup(id, info));
  }, []);

  // TODO: temporary solution, waiting on delete API call
  const updateCredentialGroupCredentials = useCallback((id: number, credentialIds: number[]) => {
    return dispatch(updateCredentialsGroup(id, { data_credentials: credentialIds }));
  }, []);

  return {
    loadCredentialsGroup,
    loadCredentialsGroups,
    createCredentialsGroup,
    updateCredentialsGroupInfo,
    updateCredentialGroupCredentials,
  };
}
